import { FlowActionTypes, FlowContext } from 'contexts/FlowContext';
import type { FC } from 'react';
import { useContext } from 'react';
import EntityPicker from './EntityPicker';

interface FlowPortSettingsProps {
  locked?: boolean;
  configPath: Array<string>;
  // component?: Component;
}
const FlowPortSettings: FC<FlowPortSettingsProps> = ({ locked, configPath }) => {
  const ctx = useContext(FlowContext);
  const flowPorts = ctx?.state.flow?.getFlowPorts() || {};
  if (
    ctx?.state.selectedComponent &&
    'flowPort' in ctx.state.selectedComponent &&
    ctx.state.selectedComponent.flowPort in flowPorts
  ) {
    const portKey = ctx.state.selectedComponent.flowPort;
    const flowPort = flowPorts[portKey];

    return (
      <EntityPicker
        key={portKey}
        property="schema"
        entityUUID={flowPort.schema}
        description="Structure of the output of the flow"
        entity="structure"
        label="Select a Structure"
        // error={propertyErrors.length > 0}
        isEditable={locked !== true}
        showEntityLink
        onChange={(key, val) => {
          // updateProperty([key], val, true);
          // eslint-disable-next-line no-console
          console.log(key, val);
          ctx.dispatch({
            type: FlowActionTypes.UPDATE_FLOW_SETTING,
            payload: {
              property: ['outputs', portKey, 'schema'],
              value: val
            }
          });
        }}
      />
    );
  }

  return <>Not a flowPort</>;
};

export default FlowPortSettings;
